module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sprouter-label",
    class: {
      active: _vm.isActive, lighten: _vm.lighten
    },
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.labelName) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d2d2c13a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionTalking/Label.vue
// module id = 687
// module chunks = 0